// extracted by mini-css-extract-plugin
export default {"subtitle":"accordions_subtitle__Ne7yp"};